import $ from 'jquery';
import TemplateView from 'picnic/core/views/Template';
import Template from 'app/cms/products/views/Locations.html';


const
	CLASS_ACTIVE = 'is-active'
;


class View extends TemplateView {

	get template() {
		return Template;
	}

	get data() {
		return {
			locations: this.options.locations
		};
	}

	events() {
		return {
			'keydown input': '_onKeypress'
		};
	}

	destroy() {
		this.$el.off('keydown');
		super.destroy();
	}

	/**
	 * Keypress event
	 * @param {object} e
	 */
	_onKeypress(e) {
		const
			key = e.keyCode || e.which,
			$el = $(this.content).children()
		;

		var index = $el.filter('.' + CLASS_ACTIVE).index();

		switch (key) {
			case 40:
				this.active = $el.eq((++index) < $el.length ? index : 0);
				break;
			case 38:
				this.active = $el.eq(index - 1);
				break;
		}

		if (this.active && this.active.length) {
			this.active.addClass(CLASS_ACTIVE).focus().siblings().removeClass(CLASS_ACTIVE);
		}
	}

}

export default View;
